import { Address } from "@/Common/Api/Contacts/Dto/Address";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { Person } from "@/Common/Models/Person/Person";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";

interface IMatchingCriterias {
    healthCardNumber: boolean;
    dateOfBirth: boolean;
    address: boolean;
    firstName: boolean;
    lastName: boolean;
    phone1: boolean;
    phone2: boolean;
    phone3: boolean;
    identifier01: boolean;
}

class MatchingCriteriaService {
    public static GetMatchingCriteriaForPerson(currentPatient: Person, otherPatient: Person): IMatchingCriterias | null {
        if (!currentPatient || !otherPatient)
            return null;

        const phoneByPriority = otherPatient.GetPhonesByPriority();

        return {
            healthCardNumber: otherPatient.NAM && currentPatient.NAM
                ? otherPatient.NAM === currentPatient.NAM
                : false,
            dateOfBirth: otherPatient.DateofBirth && currentPatient.DateOfBirth
                ? LuxonDateTimeParser.parse(otherPatient.DateofBirth).hasSame(LuxonDateTimeParser.parse(currentPatient.DateOfBirth), "day")
                : false,
            address: this.isAddressMatch(otherPatient.Addresses?.firstPreferredOrDefault(p => p.IsPreferred), currentPatient.Addresses ?? []),
            firstName: currentPatient.FirstName?.trim() && otherPatient.FirstName?.trim()
                ? currentPatient.FirstName.trim().toUpperCase() == otherPatient.FirstName.trim().toUpperCase()
                : false,
            lastName: currentPatient.LastName?.trim() && otherPatient.LastName?.trim()
                ? currentPatient.LastName.trim().toUpperCase() == otherPatient.LastName.trim().toUpperCase()
                : false,
            phone1: this.isPhoneMatch(phoneByPriority?.[0]?.Model, currentPatient.Phones),
            phone2: this.isPhoneMatch(phoneByPriority?.[1]?.Model, currentPatient.Phones),
            phone3: this.isPhoneMatch(phoneByPriority?.[2]?.Model, currentPatient.Phones),
            identifier01: currentPatient.Identifier01 && otherPatient.Identifier01
                ? currentPatient.Identifier01 === otherPatient.Identifier01
                : false
        };
    }

    private static isPhoneMatch(phone: PhoneNumber, phones: PhoneNumber[]): boolean {
        if (phone && phones?.length > 0) {
            for (let otherPhone of phones) {
                if (otherPhone.Number == phone.Number && otherPhone.CountryLookupId === phone.CountryLookupId)
                    return true;
            }
        }
        return false;
    }

    private static isAddressMatch(address: Address, addresses: Address[]): boolean {
        if (address && addresses?.length > 0) {
            for (let otherAddress of addresses) {
                if (address.StreetAddress === otherAddress.StreetAddress
                    && address.City === otherAddress.City
                    && address.ZipCode === otherAddress.ZipCode
                    && address.StateLookupId === otherAddress.StateLookupId
                    && address.CountryLookupId === otherAddress.CountryLookupId
                ) {
                    return true;
                }
            }
        }
        return false;
    }
}

export { IMatchingCriterias, MatchingCriteriaService };
